import { addAuthInterceptors } from '@dentalux/security'
import axios from 'axios'

const insightClient = axios.create({
  baseURL: process.env.REACT_APP_INSIGHT_URI,
  withCredentials: true,
})

addAuthInterceptors(insightClient)

export default insightClient
